import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "filter-item" }
const _hoisted_2 = { class: "range-panel" }
const _hoisted_3 = { class: "range-input-row" }
const _hoisted_4 = { class: "reset-container" }

import { ref, watch, computed } from 'vue';

// 定义组件props

export default /*@__PURE__*/_defineComponent({
  __name: 'GradeRangeFilter',
  props: {
    selectedType: {},
    selectedRange: {},
    maxValue: {},
    classId: {},
    selectedExamId: {},
    subject: {},
    orderDirection: {},
    passLineOffset: {},
    lineGroupId: {},
    studentId: {}
  },
  emits: ["update:selectedType", "update:selectedRange", "filterChange"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// 定义组件事件
const emit = __emit;

// 状态管理
const typeVisible = ref(false);
const rangeVisible = ref(false);
const selectedType = ref<typeof props.selectedType>(props.selectedType || null);
const rangeStart = ref<number | undefined>(props.selectedRange?.start);
const rangeEnd = ref<number | undefined>(props.selectedRange?.end);

// 动态计算当前选中的类型文本
const currentTypeText = computed(() => {
  switch (selectedType.value) {
    case 'score':
      return '分数';
    case 'gradeRank':
      return '段次';
    case 'classRank':
      return '班次';
    default:
      return '选择类型';
  }
});

// 动态计算当前选中的区间文本
const currentRangeText = computed(() => {
  if (!rangeStart.value || !rangeEnd.value) {
    return '填写区间';
  }
  
  return `${rangeStart.value}-${rangeEnd.value}`;
});

// 监听props变化
watch(() => props.selectedType, (val) => {
  selectedType.value = val;
});

watch(() => props.selectedRange, (val) => {
  rangeStart.value = val?.start;
  rangeEnd.value = val?.end;
});

// 重置区间选择
const resetRangeValues = () => {
  rangeStart.value = undefined;
  rangeEnd.value = undefined;
};

// 处理重置按钮
const handleReset = () => {
  resetRangeValues();
  emit('update:selectedRange', null);
  emit('filterChange', { 
    type: selectedType.value, 
    range: null,
    class_id: props.classId,
    selected_exam_id: props.selectedExamId,
    subject: props.subject,
    order_direction: props.orderDirection,
    pass_line_offset: props.passLineOffset,
    pass_line_id: props.lineGroupId,
    student_id: props.studentId,
    // 重置时清除所有区间参数
    min_score: undefined,
    max_score: undefined,
    min_rank: undefined,
    max_rank: undefined,
    min_class_rank: undefined,
    max_class_rank: undefined
  });
  rangeVisible.value = false;
};

// 类型选择显示控制
const handleTypeVisibleChange = (visible: boolean) => {
  typeVisible.value = visible;
  if (visible) rangeVisible.value = false;
};

// 区间选择显示控制
const handleRangeVisibleChange = (visible: boolean) => {
  if (selectedType.value) {
    rangeVisible.value = visible;
    if (visible) typeVisible.value = false;
  }
};

// 类型选择处理
const handleTypeSelect = ({ key }: { key: string }) => {
  const type = key as 'score' | 'gradeRank' | 'classRank';
  
  selectedType.value = type;
  emit('update:selectedType', type);
  
  // 选择类型后不默认选择区间，保持为空
  resetRangeValues();
  emit('update:selectedRange', null);
  
  emit('filterChange', {
    type,
    range: null,
    class_id: props.classId,
    selected_exam_id: props.selectedExamId,
    subject: props.subject,
    order_direction: props.orderDirection,
    pass_line_offset: props.passLineOffset,
    pass_line_id: props.lineGroupId,
    student_id: props.studentId,
    min_score: undefined,
    max_score: undefined,
    min_rank: undefined,
    max_rank: undefined,
    min_class_rank: undefined,
    max_class_rank: undefined
  });
  
  typeVisible.value = false;
};

// 区间输入变化处理
const handleRangeChange = () => {
  if (rangeStart.value !== undefined && rangeEnd.value !== undefined && selectedType.value) {
    const range = {
      start: rangeStart.value,
      end: rangeEnd.value
    };
    
    const filterData: Parameters<typeof emit>[1][1] = {
      type: selectedType.value,
      range,
      class_id: props.classId,
      selected_exam_id: props.selectedExamId,
      subject: props.subject,
      order_direction: props.orderDirection,
      pass_line_offset: props.passLineOffset,
      pass_line_id: props.lineGroupId,
      student_id: props.studentId,
      // 清除所有区间相关参数，避免冲突
      min_score: undefined,
      max_score: undefined,
      min_rank: undefined,
      max_rank: undefined,
      min_class_rank: undefined,
      max_class_rank: undefined
    };
    
    // 根据类型设置对应的参数
    if (selectedType.value === 'score') {
      filterData.min_score = range.start;
      filterData.max_score = range.end;
    } else if (selectedType.value === 'gradeRank') {
      filterData.min_rank = range.start;
      filterData.max_rank = range.end;
    } else if (selectedType.value === 'classRank') {
      filterData.min_class_rank = range.start;
      filterData.max_class_rank = range.end;
    }
    
    emit('update:selectedRange', range);
    emit('filterChange', filterData);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_icon = _resolveComponent("a-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_input_number = _resolveComponent("a-input-number")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "filter-label" }, "成绩区间筛选：", -1)),
    _createVNode(_component_a_dropdown, {
      visible: typeVisible.value,
      onVisibleChange: handleTypeVisibleChange,
      placement: "bottomLeft"
    }, {
      overlay: _withCtx(() => [
        _createVNode(_component_a_menu, { onClick: handleTypeSelect }, {
          default: _withCtx(() => [
            _createVNode(_component_a_menu_item, { key: "score" }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("分数", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "classRank" }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("班次", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "gradeRank" }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("段次", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_button, {
          class: _normalizeClass(["filter-btn", { 'active': typeVisible.value }])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(currentTypeText.value) + " ", 1),
            _createVNode(_component_a_icon, {
              type: "caret-down",
              rotate: typeVisible.value ? 180 : 0
            }, null, 8, ["rotate"])
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_dropdown, {
      visible: rangeVisible.value,
      onVisibleChange: handleRangeVisibleChange,
      placement: "bottomLeft",
      disabled: !selectedType.value
    }, {
      overlay: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_input_number, {
              value: rangeStart.value,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((rangeStart).value = $event)),
              placeholder: "开始",
              class: "range-input",
              min: 0,
              onChange: handleRangeChange
            }, null, 8, ["value"]),
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "range-separator" }, "-", -1)),
            _createVNode(_component_a_input_number, {
              value: rangeEnd.value,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((rangeEnd).value = $event)),
              placeholder: "结束",
              class: "range-input",
              min: rangeStart.value || 0,
              onChange: handleRangeChange
            }, null, 8, ["value", "min"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_button, {
              class: "reset-btn",
              onClick: handleReset
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode(" 重置 ", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_button, {
          class: _normalizeClass(["filter-btn", { 'active': rangeVisible.value, 'disabled': !selectedType.value }])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(currentRangeText.value) + " ", 1),
            _createVNode(_component_a_icon, {
              type: "caret-down",
              rotate: rangeVisible.value ? 180 : 0
            }, null, 8, ["rotate"])
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["visible", "disabled"])
  ]))
}
}

})